import Intl from 'intl';
import 'intl/locale-data/jsonp/en';

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value);
}
